export default __webpack_public_path__ + "static/media/144200101.4b017ec0.jpg";